import { ChartNoAxesCombined, Shield } from "lucide-react";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`}>
      <div className="brand__mark" aria-hidden="true">
        <Shield size={24} strokeWidth={1.8} />
        <ChartNoAxesCombined size={13} strokeWidth={2.2} />
      </div>
      <div>
        <strong>Lobos</strong>
        <span>Performance</span>
      </div>
    </div>
  );
}
